import { createRouter, createWebHistory } from 'vue-router';
import Homepage from '@/global-view/pages/public/homepage/Homepage.vue';
import LoginPage from '@/global-view/pages/public/login/Login.vue';
import Enroll from '@/global-view/pages/public/enroll/Enroll.vue';
import Portal from '@/global-view/portal/Portal.vue';
import NotFound from '@/global-view/pages/public/not-found/NotFound.vue';
import Dashboard from '@/global-view/pages/private/dashboard/Dashboard.vue';
import Programs from '@/global-view/pages/private/programs/Programs.vue';
import ViewProgram from '@/global-view/pages/private/view-program/ViewProgram.vue';
import RegisterProgram from '@/global-view/pages/private/register-program/RegisterProgram.vue';
import RegisteredProgram from '@/global-view/pages/private/registered-program/RegisteredProgram.vue';
import Account from '@/global-view/pages/private/account/Account.vue';
import Profile from '@/global-view/pages/private/account/profile/Profile.vue';
import Billing from '@/global-view/pages/private/account/billing/Billing.vue';
import Preferences from '@/global-view/pages/private/account/preferences/Preferences.vue';
import AccessibilityStatementEs from '@/global-view/pages/public/accessibility-statement/AccessibilityStatementEs.vue';
import TermsOfUseEs from '@/global-view/pages/public/terms-of-use/TermsOfUseEs.vue';
import PrivacyPolicyEs from '@/global-view/pages/public/privacy-policy/PrivacyPolicyEs.vue';
import AcuerdoDeConfidencialidad from '@/global-view/pages/public/program-terms/AcuerdoDeConfidencialidad.vue';
import PatrocinarEstudiante from '@/global-view/pages/public/sponsor-student/PatrocinarEstudiante.vue';
import About from '@/global-view/pages/public/about/About.vue';
import Admissions from '@/global-view/pages/public/admissions/Admissions.vue';
import NoteFromPresident from '@/global-view/pages/public/note-from-president/NoteFromPresident.vue';
import Curriculum from '@/global-view/pages/public/curriculum/Curriculum.vue';
import EnrollmentFallback from '@/global-view/pages/private/enrollment-fallback/EnrollmentFallback.vue';

const routes = [
  {
    path: '/',
    name: 'home-page',
    component: Homepage,
  },
  {
    path: '/iniciar-sesion',
    name: 'login-page',
    component: LoginPage,
  },
  {
    path: '/inscribirse',
    name: 'enroll-page',
    component: Enroll,
  },
  {
    path: '/acerca-de-lcu',
    name: 'about-page',
    component: About,
  },
  {
    path: '/admisiones',
    name: 'admissions-page',
    component: Admissions,
  },
  {
    path: '/nota-del-presidente',
    name: 'note-from-president-page',
    component: NoteFromPresident,
  },
  {
    path: '/plan-de-estudios',
    name: 'curriculum-page',
    component: Curriculum,
  },
  {
    path: '/patrocinar-estudiante',
    name: 'patrocinar-estudiante-page',
    component: PatrocinarEstudiante,
  },
  {
    path: '/no-encontrado',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/portal',
    name: 'portal',
    redirect: '/panel-de-control',
    component: Portal,
    children: [
      {
        path: '/panel-de-control',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          auth: true,
        },
      },
      {
        path: '/programas',
        name: 'programs',
        component: Programs,
        meta: {
          auth: true,
        },
      },
      {
        path: '/programas/:slug',
        name: 'view-program',
        component: ViewProgram,
        meta: {
          auth: true,
        },
      },
      {
        path: '/panel-de-control/inscribirse',
        name: 'enrollment-fallback',
        component: EnrollmentFallback,
        meta: {
          auth: true,
        },
      },
      {
        path: '/programas/registrarse/:slug',
        name: 'register-program',
        component: RegisterProgram,
        meta: {
          auth: true,
        },
      },
      {
        path: '/programas/registrada/:slug',
        name: 'registered-program',
        component: RegisteredProgram,
        meta: {
          auth: true,
        },
      },
      {
        path: '/cuenta',
        name: 'account-page',
        component: Account,
        redirect: '/cuenta/perfil',
        meta: {
          auth: true,
        },
        children: [
          {
            path: '/cuenta/perfil',
            name: 'profile-page',
            component: Profile,
            meta: {
              auth: true,
            },
          },
          {
            path: '/cuenta/facturacion',
            name: 'billing-page',
            component: Billing,
            meta: {
              auth: true,
            },
          },
          {
            path: '/cuenta/preferencias',
            name: 'preferences-page',
            component: Preferences,
            meta: {
              auth: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/declaracion-de-accesibilidad',
    name: 'accessibility-statement-page',
    component: AccessibilityStatementEs,
  },
  {
    path: '/politica-de-privacidad',
    name: 'privacy-policy-page',
    component: PrivacyPolicyEs,
  },
  {
    path: '/terminos-de-uso',
    name: 'terms-of-use-page',
    component: TermsOfUseEs,
  },
  {
    path: '/acuerdo-de-confidencialidad',
    name: 'program-terms',
    component: AcuerdoDeConfidencialidad,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/no-encontrado',
  },
];

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
});
